import { LOGOUT } from '../types/log-out-types'

export const logOut = () => {
  return {
    type: LOGOUT,
  }
}
